export type ApiResult<T> =
    | { ok: true; data: T }
    | { ok: false; error: string; status?: number; notFound?: boolean }

export function success<T>(data: T): ApiResult<T> {
    return { ok: true, data }
}

export function failure(error: string, status?: number, notFound?: boolean): ApiResult<never> {
    return { ok: false, error, status, notFound }
}
